import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CFont} from "../types";


export class CMag extends BasicCPCLArg<CMag> {
  private font: CFont;

  constructor(options?: {
    /**
     * 字体
     */
    font?: CFont
  }) {
    super();
    this.font = options?.font ?? CFont.TSS16;

  }

  clause(): CommandClause {
    let fontEntity;
    switch (this.font) {
      case CFont.TSS16:
        fontEntity = new FontEntity(1, 1, 55, 0, 16);
        break;
      case CFont.TSS20:
        fontEntity = new FontEntity(1, 1, 6, 0, 20);
        break;
      case CFont.TSS20_MAX1:
        fontEntity = new FontEntity(2, 2, 6, 0, 40);
        break;
      case CFont.TSS24:
        fontEntity = new FontEntity(1, 1, 24, 0, 24);
        break;
      case CFont.TSS32:
        fontEntity = new FontEntity(1, 1, 4, 0, 32);
        break;
      case CFont.TSS24_MAX1:
        fontEntity = new FontEntity(2, 2, 24, 0, 48);
        break;
      case CFont.TSS24_MAX2:
        fontEntity = new FontEntity(3, 3, 24, 0, 72);
        break;
      case CFont.TSS28_MAX1:
        fontEntity = new FontEntity(1, 1, 7, 3, 56);
        break;
      case CFont.TSS32_MAX1:
        fontEntity = new FontEntity(2, 2, 4, 0, 64);
        break;
      case CFont.TSS32_MAX2:
        fontEntity = new FontEntity(3, 3, 4, 0, 96);
        break;
    }
    return CPCLCommand.with(this.header())
      .appendNumber(fontEntity.ex)
      .appendNumber(fontEntity.ey)
      .clause();
  }

  header(): string {
    return 'SETMAG';
  }


}

class FontEntity {
  ex: number;
  ey: number;
  family: number;
  size: number;
  height: number;

  constructor(ex, ey, family, size, height) {
    this.ex = ex;
    this.ey = ey;
    this.family = family;
    this.size = size;
    this.height = height;
  }
}

